import request from '@/utils/request'

// 查询银河打本返现活动领取记录列表
export function listRebateClaimRecord(query) {
  return request({
    url: '/played/rebate/activity/claim/record/list',
    method: 'get',
    params: query
  })
}

// 查询银河打本返现活动领取记录详细
export function getRebateClaimRecord(id) {
  return request({
    url: '/played/rebate/activity/claim/record/' + id,
    method: 'get'
  })
}

// 新增银河打本返现活动领取记录
export function addRebateClaimRecord(data) {
  return request({
    url: '/played/rebate/activity/claim/record',
    method: 'post',
    data: data
  })
}

// 修改银河打本返现活动领取记录
export function updateRebateClaimRecord(data) {
  return request({
    url: '/played/rebate/activity/claim/record',
    method: 'put',
    data: data
  })
}

// 删除银河打本返现活动领取记录
export function delRebateClaimRecord(id) {
  return request({
    url: '/played/rebate/activity/claim/record/' + id,
    method: 'delete'
  })
}
